<template>
  <div class="weixin-login">
    <div id="weixin-Img" class="qrcode-box"></div>
    <p class="weixin-tip">使用微信扫一扫登录<br></p>
    <p class="weixin-agreement">
      扫码即表示同意
<!--      <span style="color: #0059ab;">《泓庚在线服务条款》</span>-->
      <span @click="openPrivacyPolicy" style="color: #0059ab;cursor: pointer">《用户隐私协议》</span>
    </p>
  </div>
</template>

<script>
import * as req from "@/utils/request";

export default {
  name: 'HgOnlineWeixin',
  data() {
    return {}
  },
  created() {
    this.wxLogin()
  },
  methods: {
    openPrivacyPolicy() {
      window.$global.dialogVisible = true;
    },
    wxLogin() {
      let sendData = {}
      sendData.data = null
      sendData.fn = this._wxLoginFn
      sendData.vm = this
      req.Get('wechat/qr/login', sendData)
    },
    _wxLoginFn(data) {
      if (!data) {
        this.$message.error('网络连接失败 请稍后重试')
        return
      }
      if (data.code === 200) {
        let uuid = data.data.state
        // ✅ 核心修复：对后端返回的 redirect_uri 进行 URL 解码
        let decodedRedirectUri = decodeURIComponent(data.data.redirect_uri)
        // eslint-disable-next-line no-undef
        new WxLogin({
          self_redirect: false,
          id: 'weixin-Img',
          appid: data.data.appid,
          scope: data.data.scope,
          redirect_uri: decodedRedirectUri, // 使用解码后的地址
          state: data.data.state,
          style: 'black',
          href: ''
        })
        return
      }
      this.$message.error(data.message)
    }
  }
}
</script>

<style scoped>
.weixin-login {
  width: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

/* 容器尺寸用 rem 表示，匹配微信组件大小 */
.qrcode-box {
  width: 3rem;   /* 300px */
  height: 3.4rem; /* 330px */
  margin: 0;
  padding: 0;
  overflow: visible;
}

.weixin-tip {
  font-size: 0.18rem; /* 12px */
  color: #666;
  text-align: center;
  line-height: 1.5;
  margin: 0.04rem 0 0.06rem 0;
  background-color: white;
}

.weixin-agreement {
  font-size: 0.18rem; /* 11px */
  color: #999;
  text-align: center;
  line-height: 1.4;
  margin: 0 0 0.08rem 0;
  /* margin-top: 0.3rem; */
}

/* 全局样式（去掉 scoped） */
#weixin-Img {
  width: 300px;
  height: 330px;
  margin-top: -40px;
}
#weixin-Img iframe {
  width: 100% !important;
  height: 100% !important;
  border: none;
}
#weixin-Img .impowerBox .title {
  display: none!important;
  font-size: 0px!important;
}
</style>

<style>


/* 强制微信 iframe 用 rem 完整显示 */
#weixin-Img iframe {
  width: 3.5rem !important;
  height: 4rem !important;
  min-width: 300px !important;
  min-height: 300px !important;
  border: none !important;
  overflow: visible !important;
}

/* 重置微信组件内部样式，用 rem 控制 */
#weixin-Img .impowerBox {
  //width: 3rem !important;
  margin: 0 auto !important;
  font-size: 0px!important;
  padding: 0 !important;
}
#weixin-Img .impowerBox .qrcode {
  width: 3rem !important; /* 220px */
  height: 3rem !important;
  font-size: 0px!important;
}
#weixin-Img .impowerBox .status {
  display: none !important;
  font-size: 0px!important;
}
#weixin-Img .impowerBox .title {
  display: none!important;
  font-size: 0px!important;
}
</style>